export default "__VITE_PUBLIC_ASSET__4912e8b5__"